import {CapacitorSQLite, SQLiteConnection} from '@capacitor-community/sqlite';
import {BaseEntity} from "@/modules/base/entity";
import {DataSource} from "typeorm";
import {Capacitor} from "@capacitor/core";
import chance from "@/modules/base/services/chance";

export const sqliteConnection = new SQLiteConnection(CapacitorSQLite);

export async function createDataSource(name: string, entities: (new () => BaseEntity)[] = []): Promise<DataSource> {
  return new DataSource({
    name,
    database: name,
    type: 'capacitor',
    driver: sqliteConnection,
    entities,
    migrations: [],
    synchronize: false,
    mode: "no-encryption",
    // logging: true,
  });
}

export async function persistDataSource(dataSource: DataSource): Promise<void> {
  const platform = Capacitor.getPlatform();

  if (platform === 'web') {
    await sqliteConnection.saveToStore(dataSource.name);
  }
}

export async function exportDataSource(dataSource: DataSource): Promise<string> {
  const dump = await CapacitorSQLite.exportToJson({
    jsonexportmode: 'full',
    database: dataSource.name,
  });

  // todo will fail, need to wait for https://github.com/jepiqueau/jeep-sqlite/issues/13
  dump.export!.tables.forEach(table => {
    table.schema!.forEach(schema => {
      if (schema.column === 'PRIMARY') {
        delete schema.column;
        Object.assign(schema, {
          constraint: 'PK_' + chance.guid().replaceAll('-', ''),
          value: `PRIMARY ${schema.value}`
        });
      }
    });
  });

  return JSON.stringify(dump.export);
}

export async function importDataSource(dataSource: DataSource, database: string): Promise<void> {
  await dataSource.dropDatabase();
  await dataSource.destroy();

  await CapacitorSQLite.deleteDatabase({database: dataSource.name});

  await CapacitorSQLite.importFromJson({
    jsonstring: database,
  });

  await dataSource.initialize();
}
